import { Link } from "react-router-dom"
import api from "../services/api";

export default function PrephysicianCardDetailed (props){



  
  const p = props.prephysicianData && props.prephysicianData.find(p =>
    p.prephysician_id === props.prephysicianModal
    );

  const u = props.prephysicianUserData && props.prephysicianUserData.find(u =>
    u.prephysician_id === props.prephysicianModal
    );

  // console.log(p) 


    const requestConnect = async (e) => {
      e.preventDefault();
      alert('connection requested ' + p.prephysician_id)
    }



//DELETE card function
const deleteCard = async (e) => {
  e.preventDefault();
  // console.log(p.prephysician_id)
  try {
    await api.delete(`/prephysician`, {
      headers: {
        // Authorization: authorizationToken
      },
      data: {
        prephysicianId: u.prephysician_id
      }
    }).then(window.location = `/prephysician`)
    // add the line above so that project list automatically shows new shorter list when project is deleted
  } catch (err) {
      console.error(err.message)
  }
}

let h5Style = {
  fontSize: '18px',
  fontWeight: '700',
  textAlign: 'center',
  margin: '0'
}

let pStyle = {
fontSize: '16px',
fontWeight: '500',
textAlign: 'left',
margin: '3px 0 0 0'
}

let labelStyle = {
fontSize: '16px',
fontWeight: '700',
textAlign: 'left',
width: '180px',
margin: '3px 10px 0 0',
}

let rowStyle = {
display: 'flex',
margin: '3px 0 0 0',
}

let blueButtonStyle = {
  border: "1px solid #80a3db",
  background: '#80a3db',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600'
}

let blackButtonStyle = {
  border: '1px solid #292929',
  background: '#292929',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600'
}

let redButtonStyle = {
  border: "1px solid red",
  background: '#F25835',
  color: "#FFF",
  borderRadius: '5px',
  textAlign: 'center',
  padding: "10px",
  margin: '0 10px 0 10px',
  width: '100px',
  fontWeight: '600' 
}

return (
  <div style={{display: 'flex'}}>
    <div style={{width: '7vw'}}></div>
    <div style={{width: '86vw', display: 'flex', justifyContent: 'center'}}>
      <div
        style={{
          width: '100%',
          maxWidth: '800px',
          margin: '40px 0 0 0'
        }}
      >
        {
          p
          ?
            <div
              key={p.prephysician_id}
              style={{
                background: '#FFF',
                border: 'none',
                borderRadius: '10px',
                padding: '20px',
                margin: '20px 10px 10px 0',
              }}>
              <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
              <h5 style = {h5Style}>
                {p.formal_name}
              </h5>
              <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
                <div>
                    <div style={rowStyle}>
                      <p style = {labelStyle}>
                        Location:
                      </p>
                      <p style={pStyle}>
                        {p.state_name}
                      </p>
                    </div>
                    <div style={rowStyle}>
                      <p style = {labelStyle}>
                        School:
                      </p>
                      <p style={pStyle}>
                        {p.institution}
                      </p>
                    </div>
                    <div style={rowStyle}>
                      <p style = {labelStyle}>
                        Availability:
                      </p>
                      <p style={pStyle}>
                        {p.available}
                      </p>
                    </div>
                    <div style={rowStyle}>
                      <p style = {labelStyle}>
                        Skills:
                      </p>
                      <p style={pStyle}>
                        {p.skills}
                      </p>
                    </div>
                    <div style={rowStyle}>
                      <p style = {labelStyle}>
                        Bio:
                      </p>
                      <p style={pStyle}>
                        {p.bio}
                      </p>
                    </div>
                </div>
                <div 
                  style={{
                    display: 'flex', 
                    justifyContent: "center",
                    margin: "40px 0 0 0",
                  }}
                >
                  {
                    u
                    ? 
                    <>
                      <Link
                        onClick={()=>props.setPrephysicianModal(p.prephysician_id)}
                        to={"/prephysicianedit"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blueButtonStyle}
                        >
                          Edit
                        </div>
                      </Link>  
                      <Link
                        onClick={()=>props.setPrephysicianModal('')}
                        to={"/prephysician"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blackButtonStyle}
                        >
                          Cancel
                        </div>
                      </Link>
                      <div
                        style={redButtonStyle}
                        onClick={e => deleteCard(e)}
                      >
                        Delete
                      </div>
                    </>
                    : props.userType === 'resident'
                    ? 
                      <>
                        <div
                          onClick={(e) => requestConnect(e)}
                          style={blueButtonStyle}
                        >
                          Connect
                        </div>
                        <Link
                          onClick={()=>props.setPrephysicianModal('')}
                          to={"/prephysician"}
                          style={{textDecoration: 'none'}}
                        >
                          <div
                            style={blackButtonStyle}
                          >
                            Go back
                          </div>
                        </Link>
                      </>
                    : props.userType === ''
                    ?  
                    <>
                      <Link
                        to={'/login'}
                        style={{textDecoration: 'none'}}
                      >
                        <div      
                          style={blueButtonStyle}
                        >
                          Connect
                        </div>
                      </Link>
                      <Link
                        onClick={()=>props.setPrephysicianModal('')}
                        to={"/prephysician"}
                        style={{textDecoration: 'none'}}
                      >
                        <div
                          style={blackButtonStyle}
                        >
                          Go back
                        </div>
                      </Link>
                    </>
                    : null
                  }
                  
                 
                </div>
            </div>
              
          : null
          
        }
      </div>
    </div>
    <div style={{width: '7vw'}}></div>
  </div>
  )                  
}


